import React, { useEffect } from "react";
import AuthLayout from "../../components/layout/AuthLayout";
import CardLayout from "../../components/cardLayout/CardLayout";
import { Box, Typography } from "@mui/material";
import { trivia } from "../../../Data";
import PageTitle from "../../components/pageTitle/PageTitle";
import { useLogEvent } from "../../hooks/api/post"; 

function HelpPage() {
  const { mutate: logEvent } = useLogEvent();
  const userInfo = JSON.parse(sessionStorage.getItem("ccAuth"));

 
  useEffect(() => {
    if (userInfo?.id) {
      logEvent({
        userId: userInfo.id,
        action_type: "HelpPage_load",
      });
    }
  }, [userInfo?.id, logEvent]);

  const triviaList = trivia.how.map((data) => {
    data.content = data.text;
    if (!data.title) data.title = "";
    return data;
  });

  return (
    <AuthLayout>
      <ContentPagePanel title="How to play" options={triviaList} />
    </AuthLayout>
  );
}

export default HelpPage;

// ✅ Subcomponents kept same
export function ContentPagePanel({ title, options }) {
  return (
    <>
      <PageTitle title={title} />
      <CardLayout>
        <TextList options={options} />
      </CardLayout>
    </>
  );
}

export function TextList({ options }) {
  return (
    <Box>
      {options?.map(({ sn, title, content }) => (
        <Typography key={sn} variant="body1" mb={1}>
          {!!title ? (
            <span style={{ fontWeight: 700 }}>
              {sn + ". " + title}:{" "}
            </span>
          ) : (
            sn + ". " + title
          )}
          <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </Typography>
      ))}
    </Box>
  );
}
